module.exports = __webpack_public_path__ + "static/media/healo-logo.9c9bdb76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/brand/brands/healo/media/healo-logo.svg
// module id = 833
// module chunks = 0